export default __webpack_public_path__ + "static/media/Protocol2.3c4dbf27.png";